import EdoProfile from './EdoProfile';

export default EdoProfile;
